import axios from "axios";

export const resetPassApi = async (credintial, lang, cookies) => {
  const token = cookies.__t0ken_amar_management;
  let data = JSON.stringify({
    newPassword: credintial.newPassword,
  });

  let config = {
    method: "post",
    url: `${process.env.REACT_APP_API}/reset-password`,
    headers: {
      lan: lang,
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
    timeout: 15000,
  };

  try {
    const res = await axios(config);
    return { success: res.data.success, res: res };
  } catch (error) {
    return { success: false, res: error };
  }
};
